<template>
  <div id="landing">
    
  </div>
</template>

<script>
  export default {
    methods: {
      Mail() {
        // window.location.href = "mailto:asd@asd.net";
      }
    },

  }
</script>

<style lang="scss" scoped>
  .game-info {
    h2 {
      font-weight: bold!important;

    }
  }

  .faded {
    background-color: rgba(0, 0, 0, 0.5);
  }

  a {
    font-weight: bold!important;
  }
  
  .contact {
    margin-top: 96px;
    a {
      font-weight: bolder;
    }
  }

  .page-header {
    min-height: 100vh;
  }

  .biggerLogo {
    width: 50%;
    max-width: 50vh;
  }

  .bigger-video video {
    height: 100vh;
    vertical-align: middle;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    position: absolute;
    width: 100vw;
    top: 50%;
    height: 100%;
    width: 100%;
    left: 50%;
    transform: translate(-50%,-50%);
    position: absolute;
    object-fit: cover;
  }

  .scroll-arrow {
    padding-top: 32px;
    position: absolute;
    bottom: 20px;
    left: 50%;
    right: 50%;
    z-index: 2;
    display: inline-block;
    -webkit-transform: translate(0, -50%);
    transform: translate(0, -50%);
    color: #fff;
    font : normal 400 20px/1 'Josefin Sans', sans-serif;
    letter-spacing: .1em;
    text-decoration: none;
    transition: opacity .3s;

    span {
      position: absolute;
      top: 0;
      left: 50%;
      right: 50%;
      width: 46px;
      height: 46px;
      margin-left: -23px;
      border: 1px solid #fff;
      border-radius: 100%;
      box-sizing: border-box;
    }

    span::after {
      position: absolute;
      top: 50%;
      left: 50%;
      right: 50%;
      content: '';
      width: 16px;
      height: 16px;
      margin: -12px 0 0 -8px;
      border-left: 1px solid #fff;
      border-bottom: 1px solid #fff;
      -webkit-transform: rotate(-45deg);
      transform: rotate(-45deg);
      box-sizing: border-box;
    }

    span::before {
      position: absolute;
      top: 0;
      left: 0;
      z-index: -1;
      content: '';
      width: 44px;
      height: 44px;
      box-shadow: 0 0 0 0 rgba(255,255,255,.1);
      border-radius: 100%;
      opacity: 0;
      -webkit-animation: sdb03 3s infinite;
      animation: sdb03 3s infinite;
      box-sizing: border-box;
    }

    @-webkit-keyframes sdb03 {
      0% {
        opacity: 0;
      }
      30% {
        opacity: 1;
      }
      60% {
        box-shadow: 0 0 0 60px rgba(255,255,255,.1);
        opacity: 0;
      }
      100% {
        opacity: 0;
      }
    }
  @keyframes sdb03 {
      0% {
        opacity: 0;
      }
      30% {
        opacity: 1;
      }
      60% {
        box-shadow: 0 0 0 60px rgba(255,255,255,.1);
        opacity: 0;
      }
      100% {
        opacity: 0;
      }
    }
  }

  .scroll-arrow:hover {
    opacity: .5;
  }

</style>



// WEBPACK FOOTER //
// src/components/views/Landing.vue